var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.showFooter()
    ? _c(
        "footer",
        {
          class: [
            _vm.channel.skin_background_footer
              ? "bg-" + _vm.channel.skin_background_footer
              : "bg-dark",
            _vm.channel.skin_footer_text
              ? "text-" + _vm.channel.skin_footer_text
              : "text-light",
          ],
        },
        [
          _c(
            "b-container",
            [
              _c(
                "b-row",
                { staticClass: "py-4 py-lg-6", attrs: { "align-v": "center" } },
                [
                  _c(
                    "b-col",
                    { staticClass: "text-center", attrs: { cols: "12" } },
                    [
                      _c("hr", { attrs: { lass: "py-5" } }),
                      _c("p", { staticClass: "m-0 smallest pt-4 pt-lg-6" }, [
                        _vm._v("© Skandinaviska Enskilda Banken AB (publ)"),
                      ]),
                    ]
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }